import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";
import { isoDateToString } from "../../util/format-date";
import { formatCurrency, toTitleCase, truncate } from "../../util/format-text";

/** ========================================================================
 * * EXPENSE CARD
 * ========================================================================== */
const ExpenseCard = ({ expense }) => {
  const { navigate } = useContext(UtilityContext);
  const classNames = () => {
    let classes = "grid pill lg:grid-cols-9";
    if (expense.status === "pending") classes += " border-yellow-600";
    return classes;
  };
  return (
    <div
      onClick={(e) => navigate(`/expenses/info?id=${expense.id}`, e)}
      className={classNames()}
    >
      <p className="text-stone-400">{isoDateToString(expense.dateCreated)}</p>
      <p className="text-stone-200 lg:col-span-3">
        {truncate(expense.description, 60)}
      </p>
      <p className="text-stone-400">{isoDateToString(expense.dueDate)}</p>
      <p className="text-stone-200">{isoDateToString(expense.datePaid)}</p>
      <p className="text-stone-400">
        {toTitleCase(
          expense.category.split("-").length > 1
            ? expense.category.split("-")[1]
            : expense.category
        )}
      </p>
      <p className="font-semibold">{expense.association}</p>
      <p className="ml-auto font-semibold">
        {formatCurrency(expense.amount)}
      </p>
    </div>
  );
};

export default ExpenseCard;
